import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { RfebmPrimaryButtonComponent } from 'src/app/ui/atoms/rfebm-primary-button/rfebm-primary-button.component';
import { RfebmSecondaryButtonComponent } from 'src/app/ui/atoms/rfebm-secondary-button/rfebm-secondary-button.component';

export interface ConfirmationModalData {
  title: string;
  message: string;
  confirmButtonText?: string;
}

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [ CommonModule, MatDialogModule, RfebmPrimaryButtonComponent, RfebmSecondaryButtonComponent ],
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationModalData
  ) {}
}
